import script from "./GoodByeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodByeDialog.vue?vue&type=script&setup=true&lang=js"

import "./GoodByeDialog.vue?vue&type=style&index=0&id=1105c7be&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1105c7be"]])

export default __exports__